// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CrmUserEntityMapper from "../entity-mapper/CrmUserEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = CrmUserEntityMapper.execute;

var UserResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var UserResponseConverter = partial_arg(UserResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  UserResponseConverterConfig ,
  UserResponseConverter ,
  
}
/* UserResponseConverter Not a pure module */
